/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/button-has-type */
import React from 'react';
import { useSelector } from 'react-redux';
import AddBook from './AddBook/AddBook';
import BookListHeader from './BookList/BookListHeader/BookListHeader';
import BookLists from './BookList/BookLists/BookLists';

function Main() {
  const status = useSelector(state => state.status);
  const { editMode, editInfo } = status;
  return (
    <>
      <main className="py-12 2xl:px-6">
        <div className="container grid xl:grid-cols-[auto_350px] 2xl:grid-cols-[auto_400px] gap-4 2xl:gap-8">
          <div className="order-2 xl:-order-1">
            <BookListHeader />
            <BookLists />
          </div>
          <AddBook editMode={editMode} editInfo={editInfo} />
        </div>
      </main>
    </>
  );
}

export default Main;
